import { createAction } from 'redux-actions';

import { OrderPriceQueryQuery } from '@websky/graphql';

export const SET_ORDER_PRICE = 'SET_ORDER_PRICE';
export const setOrderPrice = createAction<OrderPriceQueryQuery['OrderPrice']>(SET_ORDER_PRICE);
